import App from '@components/blog/ShareableButtons.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';

import VueSocialSharing from 'vue-social-sharing'

const axios = generateAxiosInstance();
generateApplication(App, "#share-buttons", {
  injections: [{name: '$axios', module: axios}, { name: 'locale', module: locale }],
  props: { icons },
  packages: [VueSocialSharing]
})